import { ViewIds } from '@ardoq/api-types';
import { TableviewWrapper, setup } from './common/tableviewWrapper';
import { TableViewProps } from './common/types';
import { createViewModel$ } from './referenceTableViewModel$';

const ReferenceTableViewBase = ({
  viewState,
  viewModel,
  locale,
  i18nLocale,
  userHasWriteAccess,
}: TableViewProps) => (
  <TableviewWrapper
    viewId={ViewIds.REFERENCETABLE}
    name="ReferenceTableview"
    sortable
    viewState={viewState}
    viewModel={viewModel}
    locale={locale}
    i18nLocale={i18nLocale}
    userHasWriteAccess={userHasWriteAccess}
  />
);

export const ReferenceTableView = setup(
  ViewIds.REFERENCETABLE,
  ReferenceTableViewBase,
  createViewModel$
);
